import { Modal } from '@lounge-fe/ui-kit'
import { PropsWithChildren } from 'react'

export const SelectStoreModal = ({ children }: PropsWithChildren) => {
  return <Modal>{children}</Modal>
}
